// Entscheidet, ob das schmale oder das breite Layout gilt.
//
// Zuvor verglichen drei Komponenten unabhängig voneinander per jQuery
// $(window).width() > $(window).height(). Das Kriterium war das
// Seitenverhältnis, nicht die Breite — ein quer gehaltenes Handy bekam dadurch
// das Desktop-Layout mit voller Menüleiste.
//
// Die Grenze entspricht dem Breakpoint in index.css. Wird sie dort geändert,
// muss sie hier mitgezogen werden.

export const MOBILE_QUERY = '(max-width: 640px)';

// Geraeteklasse fuer die Spaltenzahl. Die Breite allein genuegt dafuer nicht:
// iPads melden sich seit iPadOS 13 als Mac, und quer gehalten sind sie so breit
// wie ein Rechnerfenster — ein Tablet bekam dadurch die Rechner-Einstellung.
// Das Zeigegeraet verraet es dagegen: Touch heisst Handy oder Tablet, eine Maus
// heisst Rechner, auch im schmal gezogenen Fenster. Rechner mit Touchscreen
// melden 'fine', ihr Hauptzeigegeraet ist die Maus.
export const TOUCH_QUERY = '(pointer: coarse)';

function kenntZeiger() {
  // Browser ohne das Merkmal 'pointer' geben die Abfrage als 'not all' zurueck.
  return window.matchMedia(TOUCH_QUERY).media !== 'not all';
}

export function currentDevice() {
  const schmal = window.matchMedia(MOBILE_QUERY).matches;
  if (!kenntZeiger()) {
    return schmal ? 'mobile' : 'web';
  }
  if (!window.matchMedia(TOUCH_QUERY).matches) {
    return 'web';
  }
  return schmal ? 'mobile' : 'tablet';
}

// Wie observeLayout, aber fuer die Geraeteklasse: beide Abfragen koennen sich
// aendern, die Breite beim Drehen und der Zeiger beim Andocken einer Maus.
export function observeDevice(handler) {
  const listen = [window.matchMedia(MOBILE_QUERY), window.matchMedia(TOUCH_QUERY)];
  const reagieren = () => handler(currentDevice());
  listen.forEach((liste) => {
    if (liste.addEventListener) {
      liste.addEventListener('change', reagieren);
    } else {
      liste.addListener(reagieren);
    }
  });
  return () =>
    listen.forEach((liste) => {
      if (liste.removeEventListener) {
        liste.removeEventListener('change', reagieren);
      } else {
        liste.removeListener(reagieren);
      }
    });
}

export function currentLayout() {
  return window.matchMedia(MOBILE_QUERY).matches ? 'mobile' : 'web';
}

// Ruft handler bei jedem Wechsel mit 'mobile' oder 'web' auf. Der Rückgabewert
// hebt die Beobachtung wieder auf.
export function observeLayout(handler) {
  const liste = window.matchMedia(MOBILE_QUERY);
  const reagieren = (event) => handler(event.matches ? 'mobile' : 'web');

  // addEventListener erst ab Safari 14; addListener ist der Fallback.
  if (liste.addEventListener) {
    liste.addEventListener('change', reagieren);
    return () => liste.removeEventListener('change', reagieren);
  }
  liste.addListener(reagieren);
  return () => liste.removeListener(reagieren);
}
